import * as React from "react";
import { SVGProps } from "react";

export const AnalysisLegendIcon = (
  props: SVGProps<SVGSVGElement>,
  fill: string
) => (
  <svg viewBox={"0 0 24 24"} fill="none" {...props}>
    <circle cx={6} cy={6} r={6} fill={fill} />
  </svg>
);
